import MainLayout from "../../../components/MainLayout/MainLayout";
import { appServerSideProps } from "../../../utils/getAppService";
import Link from "next/link";
import Head from "next/head";
import Image from "next/image";
import client from "../../../components/contentful/Contentful";
import BlogCard from "../../../components/contentfulBlogs/BlogCard";
import Accordion from "../../../components/accordion/Accordion";
import DraftKings from "../../../assets/images/value-finder/DraftKings.png";
import FanDuel from "../../../assets/images/value-finder/Fan_Duel.png";
import Caesars from "../../../assets/images/value-finder/Caesars.png";
import BetMGM from "../../../assets/images/value-finder/BetMGM.png";
import { accordionData } from "../../welcome";
import Utils from "../../../utils/Utils";
import RichTextDisplay from "../../../components/richtext/display";

const bettingSites = {
  DraftKings: {
    src: DraftKings.src,
    alt: "DraftKings Logo",
  },
  FanDuel: {
    src: FanDuel.src,
    alt: "FanDuel Logo",
  },
  Caesars: {
    src: Caesars.src,
    alt: "Caesars Logo",
  },
  BetMGM: {
    src: BetMGM.src,
    alt: "BetMGM Logo",
  },
};

export default function Picks({ user, blogs, picks }) {
  return (
    <MainLayout>
      <Head>
        <title>College Basketball Pregame Projections</title>
        <meta
          name="description"
          content={`Get today's free College Basketball picks powered by the best data in basketball. ShotQuality predictions helps you make smarter betting decisions this NCAAB season.`}
        />
      </Head>
      <div className="m-2 mt-5">
        <div className="container-picks-and-predictions">
          <h1 className="mt-4 mb-4">College Basketball Pregame Projections</h1>
          {/* <h3>Today's NCAAB Basketball Picks:</h3> */}
          <div className="games-picks-and-predictions mt-4">
            {picks ? (
              picks.map((game) => <CardPicksAndPredictions game={game} user={user} key={game.game_id} />)
            ) : (
              <h6 className="text-center w-100 mb-5 pb-5 pt-5 mt-5">
                Oops! No Picks Found for the day. Please check back later.
              </h6>
            )}
          </div>
          <CallToActionPicksAndPredictions />
          <hr /> <br />
          <div className="row mb-3">
            {blogs.length > 0 ? (
              blogs.map((post, index) => (
                <div key={"blog" + index} className="col-lg-4 col-md-6 col-sm-12 pb-5">
                  <BlogCard post={post} isFromHomePage="blog" source={"picks"} user={user} />
                </div>
              ))
            ) : (
              <h5>No Blogs Found</h5>
            )}
          </div>
        </div>
        <section
          className="container-picks-and-predictions about-picks-and-predictions mb-4"
          id="about-picks-and-predictions"
        >
          <h4>What are ShotQuality College Basketball Free Pregame Projections? </h4>
          <p>
            ShotQuality&apos;s player location data powers the sharpest basketball predictions. From the seasons start
            through to the climactic March Madness and the Final Four we analyze every game and provide picks and
            predictions for totals and against the spread.
          </p>
          <p>
            On this page, you'll discover the finest college basketball odds, along with our handpicked NCAA basketball
            top bets for the season's most significant matchups.
          </p>
          <p>
            These selections are analyzed through the lens of ShotQuality data which secures the best value in NCAAB
            betting.
          </p>
        </section>
        <section
          className="container-picks-and-predictions about-picks-and-predictions mb-4"
          id="more-about-picks-and-predictions"
        >
          <h4>Free College Basketball Expert Picks</h4>
          <p>
            Luck isn&apos;t a winning strategy. Data drives intelligent NCAA basketball picks. ShotQuality&apos;s NCAAB
            picks cover spreads, totals, and account for odds from the major sportsbooks.
          </p>
          <h4>Free College Basketball Point Spread Picks </h4>
          <p>
            College basketball point spreads even the odds between two teams, offering bettors as close to an even pick
            as possible. Our data exposes vital stats, matchups, injuries, and more to give you the best possible edge
            before making your NCAAB point spread bets.
          </p>
          <h4>Free College Basketball Totals Picks </h4>
          <p>
            ShotQuality data makes college basketball Over/Under picks throughout the NCAA basketball season. Betting on
            NCAAB Over/Unders means picking whether you think the combined total score of a game will be Over or Under a
            specific total set by oddsmakers.
          </p>
          {/* <h4>Maximize Closing Line Value</h4> */}
          {/* <p>ShotQuality gives you the early edge and maximizes Closing Line Value for spreads and totals picks.</p> */}
        </section>
        <section className="container accordion-container ">
          <div className="mt-5 box col-md-12 text-center titles-container align-items-center justify-content-center mb-4">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="row mb-5" itemScope itemType="https://schema.org/FAQPage">
            {accordionData.slice(0, 3).map(({ name, acceptedAnswer, id }) => {
              return (
                <div key={id} className="col-md-6 faq-item">
                  <Accordion title={name} content={acceptedAnswer.text} id={id} key={name} />
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </MainLayout>
  );
}

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;
  const token = appService.getToken();

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  if (Utils.isTrader(user)) {
    return {
      redirect: {
        destination: "/trader-dashboard",
        permanent: false,
      },
    };
  }
  const res = await client.getEntries({
    content_type: "blog",
    "fields.targetSite[in]": "ShotQualityBets",
    // order: "-sys.createdAt",
    order: "-fields.published",
  });

  let picks = null;
  try {
    const picksResponse = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/college_mens/value-finder/games/picks` +
        (user?.has_paid ? "" : "/unprotected"),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    let picksData = await picksResponse.json();
    picks = picksData?.data || null;
    if (picks) {
      for (let i = 0; i < picks.length; i++) {
        picks[i].table = [];
        const keys = Object.keys(bettingSites);
        keys.forEach((key) => {
          if (picks[i][key]) {
            picks[i].table.push({
              name: key,
              currentLine: picks[i][key],
              lineValue: picks[i].is_spread
                ? (Math.abs(picks[i]["Projected (Home)"]) - Math.abs(picks[i][key])).toFixed(2)
                : Math.abs(picks[i]["Projected Home Score"] + picks[i]["Projected Away Score"] - picks[i][key]).toFixed(
                    2
                  ),
            });
          }
        });
      }
    }
  } catch (error) {
    console.error(error);
    console.log("picks error in picks page");
  }

  const blogs = res.items.filter((blog) => JSON.stringify(blog.metadata.tags).includes("picks")).slice(0, 3);
  return { props: { user, blogs, picks } };
});

function CallToActionPicksAndPredictions() {
  return (
    <div className="call-to-action-picks-and-predictions">
      {/* <Image src="/favicon_old_v2.png" width={75} height={75} alt="logo" />
      <div className="mid-text">See all available NCAAB picks, predictions, and odds.</div>
      <Link className="call-to-action" href="/ncaa/linevalue">
        Today's Picks and Predictions
      </Link> */}
    </div>
  );
}

function CardPicksAndPredictions({ game, user }) {
  let playTo = null;
  if (game.Consensus) {
    if (!game.is_spread && game["Side with Value"] === "over") {
      playTo = game.Consensus + 5;
    } else if (!game.is_spread && game["Side with Value"] === "under") {
      playTo = game.Consensus - 5;
    } else if (game.is_spread && game["Side with Value"] === game.Home) {
      playTo = game.Consensus - 4;
    } else if (game.is_spread && game["Side with Value"] === game.Away) {
      playTo = game.Consensus + 4;
    }
  }
  return (
    <div className="card-picks-and-predictions pt-2">
      <div className="team-header mb-2 mt-2">
        <div className="picks-team-name justify-end">
          <div style={{ minWidth: "100px" }}>{game.Home}</div>
          <Image
            src={`http://shotqualitybets.com/static/media/logos/${game.Home}.png`}
            width={75}
            height={75}
            alt={`logo ${game.Home}`}
            className="picks-team-logo"
          />
        </div>
        <div
          style={{
            padding: "0 10px",
          }}
        >
          at
        </div>
        <div className="picks-team-name justify-start">
          <Image
            src={`http://shotqualitybets.com/static/media/logos/${game.Away}.png`}
            width={75}
            height={75}
            alt={`logo ${game.Away}`}
            className="picks-team-logo"
          />
          {/* {game.Away} */}
          <div style={{ minWidth: "100px" }}>{game.Away}</div>
        </div>
      </div>
      <div className="date-time">
        {game.Date} - {game.Time} ET
      </div>
      {game["Consensus"] ? (
        <div className="black-ribbon">
          🤑Pick - {Utils.capitalizeFirstLetter(game["Side with Value"])} {game["Consensus"]} Play to {playTo}
        </div>
      ) : (
        <div className="black-ribbon">🔒 Members Only Pick</div>
      )}
      {game.game_preview && <div className="description">{<RichTextDisplay content={game.game_preview} />}</div>}
      <div className="lines">
        <table
          style={{
            borderSpacing: "1rem 1rem",
            borderCollapse: "separate",
          }}
        >
          <thead>
            <tr>
              <th></th>
              <th>Current Line</th>
              <th>Line Value</th>
            </tr>
          </thead>
          <tbody>
            {game.table.map((site) => (
              <tr key={site.name}>
                <td style={{ width: "200px", height: "42px", position: "relative", paddingBottom: "10px" }}>
                  <Image
                    src={bettingSites[site.name].src}
                    layout="fill"
                    objectFit="contain"
                    alt={bettingSites[site.name].alt}
                    // className="team-logo"
                  />{" "}
                  {/* {site.name} */}
                </td>
                <td>{site.currentLine}</td>
                <td>{site.lineValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Link
        href={`/ncaa/matchup-output/${game["Home"]}/${game["Away"]}/${game["Date"]}T${game["Time"]}`}
        target={"_blank"}
        className="card-button mt-4"
      >
        Matchup Preview
      </Link>
      <Link href="https://info.shotquality.com/what-is-closing-line-value" className="card-link mt-3 mb-3">
        What is closing line value?
      </Link>
    </div>
  );
}
